import HeaderButton from '@/components/elements/HeaderButton/HeaderButton';
import { HeaderButtonProps } from '@/components/elements/HeaderButton/HeaderButton.types';
import MerchantLogo from '@/components/elements/MerchantLogo/MerchantLogo';
import { MerchantLogoProps } from '@/components/elements/MerchantLogo/MerchantLogo.types';
import { Z_INDEX } from '@/constants/styleConstants';
import { classnames } from '@/helpers';
import useMobileView from '@/hooks/useMobileView';
import { HTMLAttributes, useRef } from 'react';
import { useHistory } from 'react-router-dom';

export const SEARCH_HEADER_CONTENT_HEIGHT = {
  DESKTOP: 72,
  MOBILE: 64,
} as const;

export type CheckoutHeaderProps = {
  leftSlot: { button: HeaderButtonProps; text?: string };
  middleSlot: { title: string; subtitle?: string };
  rightSlot?: Pick<MerchantLogoProps, 'imgUrl' | 'variant'>;
};

const CheckoutHeader = ({ leftSlot, middleSlot, rightSlot }: CheckoutHeaderProps) => {
  const { isMobileView } = useMobileView();
  const history = useHistory();
  const headerRef = useRef<HTMLDivElement>(null);
  const headerHeight = SEARCH_HEADER_CONTENT_HEIGHT[isMobileView ? 'MOBILE' : 'DESKTOP'];

  return (
    <header>
      <div
        className={classnames('shadow-xs bg-surface_l2 px-sm !fixed top-0 w-full')}
        style={{ zIndex: Z_INDEX.NAVBAR }}
        ref={headerRef}>
        <div
          className="gap-md container-layout bg-surface_l2 flex items-center justify-between"
          style={{ height: headerHeight }}>
          <div className="flex-1">
            <div className="text-m text-fg_secondary gap-sm flex items-center">
              <HeaderButton {...leftSlot.button} />
              {leftSlot.text && (
                <span
                  {...((): HTMLAttributes<HTMLSpanElement> => {
                    const className = 'not-sr-only hidden md:block';
                    const clickProperties = leftSlot.button.onClick;
                    if (clickProperties) {
                      return { onClick: clickProperties, className: classnames(className, 'cursor-pointer') };
                    }

                    if (leftSlot.button.item.to) {
                      return {
                        onClick: () => history.push(leftSlot.button.item.to),
                        className: classnames(className, 'cursor-pointer'),
                      };
                    }
                    return { className };
                  })()}>
                  {leftSlot.text}
                </span>
              )}
            </div>
          </div>

          <div className="gap-2xs sm:gap-3xs flex flex-col items-center justify-center overflow-hidden">
            <div className="text-fg_primary text-l sm:text-xl">{middleSlot.title}</div>
            {middleSlot.subtitle && (
              <span className="text-fg_secondary text-s sm:text-m w-full overflow-hidden text-ellipsis whitespace-nowrap text-center">
                {middleSlot.subtitle}
              </span>
            )}
          </div>

          <div className="flex flex-1 items-center justify-end">
            {rightSlot && <MerchantLogo {...rightSlot} alt="" size="md" />}
          </div>
        </div>
      </div>
      {/* Spacer */}
      <div className="bg-transparent" style={{ height: headerHeight }}></div>
    </header>
  );
};

export default CheckoutHeader;
